<template>
  <div class="pt-2">
    <!-- Floating Action Bar for bulk actions -->
    <FloatingActionBar
      :selected="selectedItems"
      :totalItems="totalItems"
      :showDeleteSelected="true"
      :show-assign="false"
      :showDeleteAll="false"
      :showUpdateStatus="false"
      :showSelectAll="false"
      @delete-selected="handleShowDialogDelete"
    />

    <div
      class="justify-end items-center"
      :class="[$vuetify.breakpoint.lgAndUp ? 'flex justify-end' : 'flex-col']"
      v-if="!showEmpInventory"
    >
      <div
        class="justify-end mr-4 mb-2"
        :class="[$vuetify.breakpoint.lgAndUp ? 'flex' : 'flex-col']"
      >
        <v-col
          class="coloms"
          :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
          :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
        >
          <v-text-field
            v-model="filterRequest"
            label="Request/Complaint Number"
            placeholder="Request/Complaint Number"
            solo
            flat
            clearable
            prepend-inner-icon="mdi-magnify"
            @input="handleInput"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
        <v-col
          class="coloms"
          :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
          :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
        >
          <v-text-field
            v-model="filterChallan"
            label="Challan Number"
            solo
            flat
            clearable
            prepend-inner-icon="mdi-magnify"
            @input="handleInput"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </div>
      <!-- Button removed from here - now managed by parent -->
    </div>
    <div v-if="showTable" class="overflow-x-auto overflow-y-auto">
      <InventoryTable
        ref="inventoryTable"
        :headers="headers"
        :expandedHeaders="expandedHeaders"
        :handler="fetchInventory"
        @expand-edit="handleExpandEdit"
      >
      </InventoryTable>
    </div>
    <div v-else-if="showEmpInventory">
      <AddEmpInventory @cancel="toggleShowTable" :innerEdit="innerEdit" />
    </div>

    <!-- Bulk Delete Confirmation Dialog -->
    <AlertPopUp
      :showConfirmationDialog="showDeleteDialog"
      :confirmationTitle="'Confirm Delete'"
      :confirmationMessage="`Do you want to delete selected requests (${selectedItems.length})?`"
      :confirmationActionText="'DELETE'"
      :confirmationActionColor="'red'"
      :performAction="deleteSelectedRequests"
      :cancel="handleShowDialogDelete"
      :loading="loading"
    />
  </div>
</template>

<script>
import AddEmpInventory from '~/components/Workforce/InventoryManagement/AddEmpInventory.vue'
import { debounce } from '@/utils/common'
import InventoryTable from './Table.vue'
import FloatingActionBar from '../CollectionManagement/CaseModules/FloatingActionBar.vue'
import AlertPopUp from '@/components/AlertPopUp.vue'

export default {
  name: 'InventoryIn',
  components: {
    InventoryTable,
    AddEmpInventory,
    FloatingActionBar,
    AlertPopUp
  },
  data() {
    return {
      headers: [
        { text: 'Request No', value: 'reqNumber', sortable: false },
        { text: 'Challan No', value: 'challanNumber', sortable: false },
        { text: 'Request Status', value: 'reqStatus', sortable: false },
        { text: 'Complaint No', value: 'complaintNumber', sortable: false },
        { text: 'Complaint Status', value: 'complaintStatus', sortable: false }
      ],
      expandedHeaders: [
        { text: 'Product Name', value: 'productName', sortable: false },
        { text: 'Store Name', value: 'storeName', sortable: false },
        { text: 'Assigned Qty.', value: 'qtyAssigned', sortable: false },
        { text: 'Used Qty.', value: 'qtyUsed', sortable: false },
        { text: 'Returned Qty.', value: 'qtyReturned', sortable: false },
        { text: 'Assigned To', value: 'assignedBy', sortable: false },
        { text: 'Given By', value: 'givenBy', sortable: false },
        { text: 'Collected By', value: 'collectedBy', sortable: false },
        { text: 'Returned To', value: 'returnedTo', sortable: false },
        { text: 'Delivery Mode', value: 'deliveryMode', sortable: false },
        { text: 'Tracking No.', value: 'tracking', sortable: false },
        { text: 'Status', value: 'expandStatus', sortable: false },
        { text: 'Action', value: 'expandAction', sortable: false }
      ],
      showTable: true,
      innerEdit: null,
      filterRequest: '',
      filterChallan: '',
      showEmpInventory: false,
      // For FloatingActionBar
      showDeleteDialog: false,
      loading: false,
      totalItems: 0
    }
  },
  computed: {
    selectedItems() {
      return this.$refs.inventoryTable ? this.$refs.inventoryTable.getSelectedItems() : []
    }
  },
  methods: {
    toggleShowEmpInventory() {
      // Instead of toggling internal state, emit event to parent
      this.$emit('request-add-emp-inventory')
    },
    toggleShowTable() {
      this.showEmpInventory = false
      this.innerEdit = null
      this.showTable = true
    },
    async fetchInventory({ page = '1', limit = '10' }) {
      try {
        const params = {
          page,
          limit
        }
        if (this.filterRequest) {
          params.search = this.filterRequest
        }
        if (this.filterChallan) {
          params.searchChallan = this.filterChallan
        }
        const response = await this.$axios.get('/ecom/inventory/user', {
          params: params
        })

        const data = response?.data
        data.items = data?.inventories
        this.totalItems = data?.pagination?.totalCount || 0
        return response?.data
      } catch (error) {
        console.error('An error occurred:', error)
      }
    },
    inventoryDelete(item) {
      this.selectedProduct = item._id
    },
    async handleDeleteInventory() {
      try {
        const response = await this.$axios.delete(`/ecom/product/${this.selectedProduct}`)
        await this.$refs.inventoryTable.getDataFromApi()
        const successMessage = response?.data?.message || 'Product deleted successfully!'
        this.$toast.success(successMessage)
      } catch (error) {
        const errorMessage = error.response.data.message || 'Order failed.'
        this.$toast.error(errorMessage)
      }

      this.showConfirmationDialog = false
    },
    handleInput: debounce(function () {
      this.$refs.inventoryTable.getDataFromApi()
    }, 1000),
    handleExpandEdit(item) {
      this.innerEdit = item
      // Instead of toggling internal state, emit event to parent with edit data
      this.$emit('request-edit-emp-inventory', item)
    },
    handleShowDialogDelete() {
      // Only show the dialog if there are selected items
      if (this.selectedItems.length > 0) {
        this.showDeleteDialog = true
      }
    },
    async deleteSelectedRequests() {
      this.loading = true
      try {
        const deletePromises = this.selectedItems.map((request) =>
          this.$axios.delete(`/ecom/inventory/user/${request._id}`)
        )

        await Promise.all(deletePromises)
        this.$toast.success('Selected requests deleted successfully')
        this.selectedItems = []
        this.showDeleteDialog = false
        this.$refs.inventoryTable.getDataFromApi()
      } catch (error) {
        console.error('Error deleting requests:', error)
        this.$toast.error(
          'Error deleting requests: ' + (error.response?.data?.message || error.message)
        )
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.coloms {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
